/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Go_To_EventInputs */



/**
* | output |
* | --- |
* | "Go To Event" |
*
* @param {Shortcut_Keys_Name_Go_To_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_go_to_event = /** @type {((inputs?: Shortcut_Keys_Name_Go_To_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Go_To_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aller a l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum Ereignis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai all'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти к мероприятию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ir al evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("前往活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントへ移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट पर जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ir para o evento")
	return /** @type {LocalizedString} */ ("Go To Event")
});